import httpClient from "./httpClient";
const getActiveDossiers = () => httpClient.get("/api/getActiveDossiers");
export { getActiveDossiers };
